// Plan definitions — single source of truth for feature gating and limits.
// PRICE IDs must match your Stripe Dashboard products.
// Replace the placeholder price_xxx values after creating products in Stripe.

export const PLANS = {
  starter: {
    name: 'Starter',
    maxActiveProjects: 2,
    maxTeamMembers: 1,
    maxPhotosPerProject: 50,
    features: {
      leads: false,
      scheduler: false,
      tasks: false,
      quickbooks: false,
      receiptScanning: false,
      advancedDashboard: false,
      reports: false,
      csvExport: false,
      riskMonitoring: false,
      portfolioAnalytics: false,
      salesTracking: false,
      approvalWorkflows: false,
      capitalTracking: false,
      departmentTeams: false,
      unlimitedStorage: false,
      aiAnalysis: false,
      aiAssistant: false,
    },
  },
  pro: {
    name: 'Pro',
    maxActiveProjects: 10,
    maxTeamMembers: 1,
    maxPhotosPerProject: 200,
    features: {
      leads: true,
      scheduler: true,
      tasks: true,
      quickbooks: true,
      receiptScanning: true,
      advancedDashboard: true,
      reports: true,
      csvExport: true,
      riskMonitoring: true,
      portfolioAnalytics: true,
      salesTracking: true,
      approvalWorkflows: false,
      capitalTracking: false,
      departmentTeams: false,
      unlimitedStorage: false,
      aiAnalysis: true,
      aiAssistant: true,
    },
  },
  business: {
    name: 'Business',
    maxActiveProjects: Infinity,
    maxTeamMembers: Infinity,
    maxPhotosPerProject: Infinity,
    features: {
      leads: true,
      scheduler: true,
      tasks: true,
      quickbooks: true,
      receiptScanning: true,
      advancedDashboard: true,
      reports: true,
      csvExport: true,
      riskMonitoring: true,
      portfolioAnalytics: true,
      salesTracking: true,
      approvalWorkflows: true,
      capitalTracking: true,
      departmentTeams: true,
      unlimitedStorage: true,
      aiAnalysis: true,
      aiAssistant: true,
    },
  },
};

// Map Stripe Price IDs → plan keys.
// Replace these with real price IDs from your Stripe Dashboard.
export const PRICE_TO_PLAN = {
  price_1T4xIVEKGDT5ifY28sHyLDfj: 'pro',
  price_1T4xIVEKGDT5ifY2hPyuSQL2: 'pro',
  price_1T4xJjEKGDT5ifY2qHMePMuN: 'business',
  price_1T4xJjEKGDT5ifY2LoedCtZ3: 'business',
};

// Price IDs grouped by plan and billing cycle (used by BillingSection UI).
// Replace these with real price IDs from your Stripe Dashboard.
export const PRICE_IDS = {
  pro: {
    monthly: 'price_1T4xIVEKGDT5ifY28sHyLDfj',
    annual: 'price_1T4xIVEKGDT5ifY2hPyuSQL2',
  },
  business: {
    monthly: 'price_1T4xJjEKGDT5ifY2qHMePMuN',
    annual: 'price_1T4xJjEKGDT5ifY2LoedCtZ3',
  },
};
